import PageHeader from '../molecules/PageHeader';
import SearchChildByParentID from '../molecules/SearchChildByParentId/SearchChildByParentID';

const RegisterContinue = ({ searchResultSetter }) => {
  return (
    <div>
      <PageHeader>Continue Registration</PageHeader>

      <SearchChildByParentID
        searchInfoSetter={searchResultSetter}
        label='To proceed, please enter the Email Address that was registered previously:'
      />
    </div>
  );
};

export default RegisterContinue;
